import React, { useState } from 'react';
import '../styles/changepassword.css';
import visibilityIcon from '../assets/visibility.png';
import HiddenIcon from '../assets/hidden.png';


const ChangePasswordPage = () => {

  const [showPassword, setShowPassword] = useState(false);
  const [showcPassword, setShowcPassword] = useState(false);
  const [shownewPassword, setShownewPassword] = useState(false);
  
  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const toggleConfirmPasswordVisibility = () => setShowcPassword(!showcPassword);
  const toggleNewConfirmPasswordVisibility = () => setShownewPassword(!shownewPassword);
  return (
    <div className="password-container">
      <aside className="sidebar">
        <div className="avatar" />
        <div className="menu">
          <button>📄 Subscription</button>
          <button className="active">🔑 Change Password</button>
          <button>🚪 Logout</button>
        </div>
      </aside>

    <form className="password-class">
    <div className="password-form">
      <label> Old Password</label>
        <div className='passwordo'>
        <input
          type={showPassword ? 'text' : 'password'}
          placeholder="Enter old password"
          className="password-input"
        />
        <img
          src={showPassword ? visibilityIcon : HiddenIcon}
          alt="Toggle visibility"
          className="eye-icon"
          onClick={togglePasswordVisibility}
                />
        </div>
          
        <label> New Password</label>
        <div className='passwordn'>
        <input
          type={showcPassword ? 'text' : 'password'}
          placeholder="Enter old password"
          className="password-input"
        />
        <img
          src={showcPassword ? visibilityIcon : HiddenIcon}
          alt="Toggle visibility"
          className="eye-icon"
          onClick={toggleConfirmPasswordVisibility}
                />
        </div>
        <label> Confirm New Password</label>
        <div className='passwordcn'>
        <input
          type={shownewPassword ? 'text' : 'password'}
          placeholder="Re-enter new password"
          className="password-input"
        />
        <img
          src={shownewPassword ? visibilityIcon : HiddenIcon}
          alt="Toggle visibility"
          className="eye-iconn"
          onClick={toggleNewConfirmPasswordVisibility}
                />
        </div>
        <button className="set-btn">Set Password</button>
      </div>
    </form>
      
    </div>
  );
};
export default ChangePasswordPage;